module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-products"
  }, [_c('el-dialog', {
    attrs: {
      "title": "退货关联产品",
      "visible": _vm.dialogVisible,
      "modal": false,
      "before-close": _vm.closeDialog,
      "custom-class": "product-new"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.productList,
      "border": ""
    },
    on: {
      "select-all": _vm.handleSelect,
      "select": _vm.handleSelect
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "38"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "产品名称",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNo",
      "label": "产品编号",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "70",
      "prop": "specification",
      "label": "规格",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "70",
      "prop": "priceStr",
      "label": "单价",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "148",
      "label": "数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          attrs: {
            "size": "small",
            "min": 0,
            "max": scope.row.stock,
            "debounce": 1000
          },
          on: {
            "change": function($event) {
              _vm.handleNumChange(scope.$index, scope.row.id)
            }
          },
          model: {
            value: (scope.row.num),
            callback: function($$v) {
              _vm.$set(scope.row, "num", $$v)
            },
            expression: "scope.row.num"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "label": "备注"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "textarea",
            "autosize": {
              minRows: 1,
              maxRows: 3
            }
          },
          on: {
            "change": function($event) {
              _vm.handleNumChange(scope.$index, scope.row.id)
            }
          },
          model: {
            value: (scope.row.memo),
            callback: function($$v) {
              _vm.$set(scope.row, "memo", $$v)
            },
            expression: "scope.row.memo"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "50",
      "prop": "unit",
      "label": "单位"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > _vm.productList.length),
      expression: "total > productList.length"
    }],
    staticClass: "pagination-wrapper"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "select"
  }, [_vm._v("已选产品：" + _vm._s(_vm.selectProducts.length))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0668784","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/product-new.vue
// module id = 1334
// module chunks = 82